<section>
    <h1 class="header">{{ pageData.pageTitle }}</h1>
    <div class="progress-block">
        <h3 class="progress-header">{{ pageData.header }}</h3>
        <div class="shadow-circle">
            <div class="spinner-wrapper">
                <div class="spinner"></div>
                <xm-media-image class="logo" [imageOptions]="icon" size="height"></xm-media-image>
            </div>
        </div>
        <p class="description">{{ pageData.subhead }}</p>
    </div>
</section>
